import React from 'react';
import { useDispatch } from 'react-redux';
import { type GridRowParams } from '@mui/x-data-grid-premium';

import { type MultiButtonOptionType } from 'app/main/components/buttons/MultiButton';
import { type ViewItemButtonProps } from 'app/main/components/page-layouts/view/ViewPage';
import { useSettings } from 'app/main/components';
import { DetailsAdditionalPropsContext, ViewTableUtils } from 'app/main/components/page-layouts';
import { showOrdersBillingEditDialog } from './OrdersBillingEditDialog';
import { ViewTableRowActionsMenuComponent } from 'app/main/components/page-layouts/view/table/ViewTableComponents';

interface OrdersBillingTableActionsProps {
	rowProps: GridRowParams<any>;
	order: any;
	updateRefresh: VoidFunction;
}

export default function OrdersBillingTableActions(props: OrdersBillingTableActionsProps) {
	const dispatch = useDispatch();
	const { settings } = useSettings('orders_billing');

	const { additionalProps } = React.useContext<any>(DetailsAdditionalPropsContext);

	const editLine = (isAdd?: boolean) =>
		dispatch(
			showOrdersBillingEditDialog({ baseModel: props.rowProps.row, isAdd, updateRefresh: props.updateRefresh })
		);

	const buttons: MultiButtonOptionType<ViewItemButtonProps>[] = [
		{
			name: 'VIEW_ITEM_BUTTON_EDIT',
			icon: 'edit',
			action: () => editLine(false)
		},
		{
			name: 'VIEW_ITEM_BUTTON_ADD_COPY',
			icon: 'content-copy',
			action: () => editLine(true)
		},
		{
			name: 'VIEW_ITEM_BUTTON_DELETE',
			icon: 'delete',
			action: () => additionalProps?.showDeleteBillingDialog([props.rowProps.row])
		}
	];

	return [
		ViewTableUtils.renderMenu({
			component: ViewTableRowActionsMenuComponent,
			buttonProps: { settings, updateRefresh: props.updateRefresh },
			items: buttons
		})
	];
}
